import classNames from "classnames";
import { CardVariant, MetadataType } from "types";
import { Label } from "../../index";

import TagIcon from "assets/icons/tagIcon";
import { TbEyeQuestion } from "react-icons/tb";

import styles from "./style.module.scss";
import CardMetadataLabels from "../../../../../../components/CardMetadataLabels";

export interface ReviewCardHeaderProps {
  titleIcon: JSX.Element;
  title: string;
  reviewClassLabel: Label;
  floatingDetails: string;
  isPreview: boolean;
  cardVariant: CardVariant;
}

const ReviewCardHeader = ({
  title,
  isPreview,
  titleIcon,
  cardVariant,
  floatingDetails,
  reviewClassLabel,
}: ReviewCardHeaderProps) => {
  const cardHeadClassnames = classNames(styles.reviewCardHead, {
    [styles.unClickable]: !isPreview,
    [styles.exportHeader]: cardVariant === CardVariant.SELECTED,
    [styles.similarityHeader]: cardVariant === CardVariant.VERTEX,
  });

  return (
    <div className={cardHeadClassnames}>
      <div data-testid="title-header">
        <CardMetadataLabels
          labels={[reviewClassLabel.name]}
          cardVariant={cardVariant}
          labelIcon={<TagIcon />}
          labelType={reviewClassLabel.type}
          metadataType={MetadataType.IMAGE_LABELS}
          showOptionsIcon
          interactive={false}
        />
      </div>

      <div className={styles.detailsWrapper}>
        <div className={styles.reviewHeaderTitle}>
          <div className={styles.reviewTitleIcon}>{titleIcon}</div>
          <div className={styles.reviewLabel} title={title}>
            {title}
          </div>
        </div>
        {isPreview && (
          <div className={styles.reviewDetails}>
            <TbEyeQuestion size={18} color="currentColor" />
            <div className={styles.reviewTitles}>{floatingDetails}</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReviewCardHeader;
